/** @file The IK fields an animation can key (ik.setKey channels); the rest are setup-only. */

/** mix and softness (numbers), bendPositive, stretch and compress (booleans). */
export const IK_KEYABLE = ['mix', 'softness', 'bendPositive', 'stretch', 'compress'] as const;

/** One keyable IK field. */
export type IkKeyable = (typeof IK_KEYABLE)[number];
